import { render, staticRenderFns } from "./NCBC.vue?vue&type=template&id=1899e791&scoped=true"
import script from "./NCBC.vue?vue&type=script&lang=js"
export * from "./NCBC.vue?vue&type=script&lang=js"
import style0 from "./NCBC.vue?vue&type=style&index=0&id=1899e791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899e791",
  null
  
)

export default component.exports